import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import GalleryPage from "./galleryPage";
import i18n from "./languages/i18n";
import { I18nextProvider } from "react-i18next";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ParallaxProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </I18nextProvider>
    </ParallaxProvider>
  </React.StrictMode>
);

reportWebVitals();
